import TickIcon from "@Icons/TickIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./CheckBox.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

interface Props {
  isSelected: boolean;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}
const CheckBox = (props: Props) => {
  const { isSelected, onClick = () => null, className = "", disabled = false } = props;

  return (
    <div
      role="checkbox"
      aria-checked={isSelected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? undefined : onClick}
      className={formatClassNames(
        styles.container,
        className,
        isSelected && styles.checked,
        disabled && styles.disabled,
      )}
      data-testid="checkbox-input"
      onKeyDown={(event) => {
        if (event.key === "Enter" && !disabled) {
          onClick();
        }
      }}
    >
      {isSelected && <TickIcon />}
    </div>
  );
};

export default wrapperHOC(CheckBox, {
  componentName: "CheckBox-Global",
  showForChina: true,
});
